export const CONTENT_RISK_STATUS = {
    NONE: 'none',
    LOADING: 'loading',
    FAILED: 'failed',
};

export const CONTENT_RISK_QUALITY = {
    SPAM_NOT_SENDABLE: 'SPAM',
    WARN: 'WARN',
    OK: 'OK',
};
